import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './MobileFooter.css';

const FacebookIcon = FaFacebookF as React.FC<React.SVGProps<SVGSVGElement>>;
const InstagramIcon = FaInstagram as React.FC<React.SVGProps<SVGSVGElement>>;

export const MobileFooter = () => {
	return (
		<footer className='mobile-footer'>
			<div className='footer-content'>
				<nav
					className='footer-nav'
					aria-label='Footer Navigation'
				>
					<Link
						to='/datenschutz'
						// style={{
						// 	color: '#6C5CE7',
						// 	fontWeight: 600,
						// 	textDecoration: 'none',
						// 	transition: 'color 0.3s',
						// }}
						className='link-style'
					>
						Datenschutz
					</Link>
					<Link to={'/impressum'} className='link-style'>
						Impressum
					</Link>
					<Link to={'/blog'} className='link-style'>
						Blog
					</Link>
					<Link
						to='/support'
						className='link-style'
					>
						Support
					</Link>
				</nav>

				<div className='footer-social'>
					<a
						href='https://www.facebook.com/Erledix'
						target='_blank'
						rel='noopener noreferrer'
						aria-label='Facebook'
						className='link-style'
					>
						<FacebookIcon />
					</a>
					<a
						href='https://www.instagram.com/Erledix'
						target='_blank'
						rel='noopener noreferrer'
						aria-label='Instagram'
						className='link-style'
					>
						<InstagramIcon />
					</a>
				</div>
			</div>

			<p className='footer-copyright'>
				Copyright © 2025 Erledix.<br></br> All rights reserved.
			</p>
		</footer>
	);
};
